import { render, staticRenderFns } from "./AgeGroup.vue?vue&type=template&id=4e3067bf&scoped=true&"
import script from "./AgeGroup.vue?vue&type=script&lang=js&"
export * from "./AgeGroup.vue?vue&type=script&lang=js&"
import style0 from "./AgeGroup.vue?vue&type=style&index=0&id=4e3067bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3067bf",
  null
  
)

export default component.exports